
export function pickVoices(voices) {
  var playerVoiceNumber = -1
  var engineVoiceNumber = -1
  var samantha = -1
  var daniel = -1
  var googleUS = -1
  var googleUK = -1

  //console.log("VOICES",voices)
  for (var i=0; i < voices.length; i++) {
    const oneVoice = voices[i]

    if (oneVoice.name == "Samantha" && oneVoice.lang == "en-US")
      samantha = i
    else
    if (oneVoice.name == "Daniel" && oneVoice.lang == "en-GB")
      daniel = i
    else
    if (oneVoice.name == "Google US English" && oneVoice.lang == "en-US")
      googleUS = i
    else
    if (oneVoice.name == "oogle UK English Female" && oneVoice.lang == "en-GB")
      googleUK = i
  }
  if (samantha > -1)
    playerVoiceNumber = samantha
  else
    if (googleUS > -1)
      playerVoiceNumber = googleUS
  if (daniel > -1)
    engineVoiceNumber = daniel
  else
    if (googleUK > -1)
      engineVoiceNumber = googleUK

  return ([playerVoiceNumber,engineVoiceNumber])
}

export function getListofVoices(voicesFoundCallback) {
  var voices = []
  // https://stackoverflow.com/questions/21513706/getting-the-list-of-voices-in-speechsynthesis-web-speech-api/22978802#22978802

  const allVoicesObtained = new Promise(function(resolve, reject) {
    voices = window.speechSynthesis.getVoices();
    if (voices.length !== 0) {
      resolve(voices);
    } 
    else {
      window.speechSynthesis.addEventListener("voiceschanged", function() {
        voices = window.speechSynthesis.getVoices();
        resolve(voices);
      });
    }
  });

  allVoicesObtained.then(voices => {
    const voiceNumbers = pickVoices(voices)
    voicesFoundCallback(voices,voiceNumbers[0],voiceNumbers[1])
  })
}